var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5357 6.60721H9.25V1.32146C9.25 0.591624 8.65837 0 7.92855 0C7.19872 0 6.6071 0.591624 6.6071 1.32146V6.60721H1.32145C0.591621 6.60721 0 7.19883 0 7.92866C0 8.65849 0.591621 9.25004 1.32145 9.25004H6.60717V14.5358C6.60717 15.2656 7.19879 15.8572 7.92862 15.8572C8.65845 15.8572 9.25 15.2655 9.25 14.5358V9.25004H14.5357C15.2655 9.25004 15.8572 8.65842 15.8572 7.92858C15.8572 7.19875 15.2655 6.60721 14.5357 6.60721Z",
    fill: "#0445FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.c65bd7a84ff3f1579b81108ba653f5a0.svg";
export { ForwardRef as ReactComponent };